/* Library */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import SVG from "react-inlinesvg";

/* Helpers */
import { Pagination } from "../helpers/pagination/Pagination";
import { sortCaret, headerSortingClasses } from "../../_metronic/_helpers";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import * as columnFormatters from "../helpers/column-formatters";
import {
  cetakBkpJkp,
  cetakBps,
  cetakKu,
  getDataDashboardByNpwp,
  getDataDashboardByNpwpWithStatus,
  getDetailBps,
  getDetailBpsBkp,
} from "../references/Api";
// import {
//   deleteMatrixUsulan,
//   getMatrixUsulan,
//   updateStatusMatrix,
// } from "../../../references/Api";

/* Utility */

function DashboardTable({ npwp, tab="aktif" }) {
  const history = useHistory();
  const [content, setContent] = useState([]);
  const [data, setData] = useState([]);
  const [searchTxt, setSearchTxt] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sizePage, setSizePage] = useState(30);
  //   const { user } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(true);

  const add = () => history.push("/main");
  const detail = (idSurat, noBps) => {
    const formattedString = encodeURIComponent(noBps);

    if (idSurat === 243) {
      history.push(`/kontraktor/${npwp}/${formattedString}/view`);
    } else if (idSurat === 244) {
      getDetailBpsBkp(npwp, noBps).then(({ data }) => {
        history.push(
          `/bkpjkp/bkpjkp-registrasi/${npwp}/${data.data[0].idProyek}/${formattedString}/view`
        );
      });
    }

    // history.push(`/`);
  };

  const handleCetakBps = (noBps) => {
    swal({
      title: "Loading...",
      text: "Please wait while we process your request.",
      icon: "info",
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
    });

    cetakBps(npwp, noBps)
      .then(({ data }) => {
        swal.close();

        if (data.code === 1) {
          return openPDFInNewTab(data.data, noBps);
        }else{
          swal.close();
          swal("Gagal", data.message, "error");
        }
      })
      .catch((err) => {
        swal.close();
        swal("Gagal", err.message, "error");
      });
  };

  const cetakSuket = (idSurat, noBps) => {
    if (idSurat === 243) {
      swal({
        title: "Loading...",
        text: "Please wait while we process your request.",
        icon: "info",
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });

      getDetailBps(npwp, noBps)
        .then(({ data }) => {
          // Close loading alert
          // swal.close();

          if (data) {
            if (data.data[0].id) {
              cetakKu(data.data[0].id)
                .then(({ data }) => {
                  swal.close();
                  if (data.code === 1) {
                    return openPDFInNewTab(data.data, noBps);
                  }
                })
                .catch((err) => {
                  swal.close();
                  swal("Gagal", "Maaf, status permohonan anda tidak aktif.", "error");
                  // swal("Gagal", err.message, "error");
                });
            }
          }
        })
        .catch((err) => {
          // Close loading alert on error
          swal.close();
          // swal("Gagal", err.message, "error");
          swal("Gagal", "Maaf, status permohonan anda tidak aktif.", "error");

        });
    } else if (idSurat === 244) {
      // Show loading alert
      swal({
        title: "Loading...",
        text: "Please wait while we process your request.",
        icon: "info",
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });

      getDetailBpsBkp(npwp, noBps)
        .then(({ data }) => {
          // Close loading alert
          // swal.close();
          if (data) {
            if (data.data[0].id) {
              cetakBkpJkp(data.data[0].id)
                .then(({ data }) => {
                  swal.close();
                  if (data.code === 1) {
                    return openPDFInNewTab(data.data);
                  }
                })
                .catch((err) => {
                  swal.close();
                  swal("Gagal", err.message, "error");
                });
            }
          }
        })
        .catch((err) => {
          // Close loading alert on error
          swal.close();
          swal("Gagal", err.message, "error");
        });
    }
  };

  function downloadPDF(base64String, fileName) {
    // Hapus prefix "data:application/pdf;base64," jika ada
    const base64WithoutPrefix = base64String.replace(
      /^data:application\/pdf;base64,/,
      ""
    );

    // Konversi string Base64 ke Blob
    const pdfBlob = new Blob(
      [Uint8Array.from(atob(base64WithoutPrefix), (c) => c.charCodeAt(0))],
      { type: "application/pdf" }
    );

    // Buat URL dari Blob
    const url = URL.createObjectURL(pdfBlob);

    // Buat elemen <a> untuk unduhan
    const link = document.createElement("a");
    link.href = url;
    link.download = `${fileName}.pdf`;
    document.body.appendChild(link);
    link.click();

    // Hapus elemen dan URL Blob setelah unduhan
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
  function openPDFInNewTab(base64String) {
    const base64WithoutPrefix = base64String.replace(
      /^data:application\/pdf;base64,/,
      ""
    );
    const pdfBlob = new Blob(
      [Uint8Array.from(atob(base64WithoutPrefix), (c) => c.charCodeAt(0))],
      { type: "application/pdf" }
    );
    const url = URL.createObjectURL(pdfBlob);

    // Buka URL di tab baru
    // const newTab =
    window.open(url, "_blank");

    // Hapus URL Blob setelah dibuka
    setTimeout(() => {
      URL.revokeObjectURL(url);
    }, 60000); // Adjust the delay as needed
    // if (newTab) {
    //   // Add an unload event to the new tab to revoke the URL when it is closed
    //   newTab.onbeforeunload = () => {
    //     URL.revokeObjectURL(url);
    //   };
    // } else {
    //   console.error('Failed to open new tab. Check for popup blockers.');
    // }
  }

  function openAndDownloadPDF(base64String, fileName) {
    // Remove Base64 prefix if present
    const base64WithoutPrefix = base64String.replace(
      /^data:application\/pdf;base64,/,
      ""
    );

    // Convert Base64 to Blob
    const pdfBlob = new Blob(
      [Uint8Array.from(atob(base64WithoutPrefix), (c) => c.charCodeAt(0))],
      { type: "application/pdf" }
    );

    // Create a Blob URL
    const url = URL.createObjectURL(pdfBlob);

    // Open the PDF in a new tab
    const newTab = window.open(url, "_blank");
    if (newTab) {
      // Delay the download to ensure it opens in a new tab first
      setTimeout(() => {
        const link = newTab.document.createElement("a");
        link.href = url;
        link.download = `${fileName}.pdf`;
        newTab.document.body.appendChild(link);
        link.click();
        // Remove the link after download
        newTab.document.body.removeChild(link);
      }, 500);
    }

    // Clean up the Blob URL after download
    URL.revokeObjectURL(url);
  }


  useEffect(() => {
    // switch (tab) {
    //   case "aktif":
    //     getDataDashboardByNpwpWithStatus(npwp, "AKTIF", currentPage, sizePage).then(({data})=> {
    //       setLoading(false);
    //       if(data){
    //         if (data.code === 1) {
    //           if (data.data.content.length > 0) {
    //             setContent(data.data.content);
    //             setData(data.data);
    //             setLoading(false);
    //           }
    //         } else {
    //           swal("Gagal", data.message, "error");
    //         }
    //       }
    //     }).catch((err)=> {
    //       setLoading(false);
    //       swal("Gagal", err.message, "error");
    //     })
    //     break;
    //   case "nonaktif":
    //     getDataDashboardByNpwpWithStatus(npwp, "NONAKTIF", currentPage, sizePage).then(({data})=> {
    //       setLoading(false);
    //       if(data){
    //         if (data.code === 1) {
    //           if (data.data.content.length > 0) {
    //             setContent(data.data.content);  
    //             setData(data.data);
    //             setLoading(false);
    //           }
    //         } else {
    //           swal("Gagal", data.message, "error");
    //         }
    //       }
    //     }).catch((err)=> {
    //       setLoading(false);
    //       swal("Gagal", err.message, "error");
    //     })
    //     break;
    //   default:
    //     break;
    // }
    getDataDashboardByNpwp(
      npwp, 
      currentPage, 
      sizePage,
      searchTxt ? searchTxt : ""
    )
      .then(({ data }) => {
        // console.log(data)
        setLoading(false);
        if (data) {
          if (data.code === 1) {
            if (data.data.content.length > 0) {
              setContent(data.data.content);
              setData(data.data);
              setLoading(false);
            }
          } else {
            // swal("Gagal", data.message, "error");
            setLoading(false);
            swal({
              title: "Data Tidak Tersedia!",
              icon: "info",
              closeOnClickOutside: false,
            }).then((willApply) => {
              if (willApply) {
                // history.push("/logout");
              }
            });
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        // swal("Gagal", err.message, "error");
        console.log(err.message);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, sizePage]);
  const columns = [
    {
      dataField: "any",
      text: "No",
      sort: true,
      // formatter: columnFormatters.IdColumnFormatter,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (cell, row, rowIndex) => {
        let rowNumber = (currentPage - 1) * sizePage + (rowIndex + 1);
        return <span>{rowNumber}</span>;
      },
    },
    {
      dataField: "noBps",
      text: "id",
      sort: true,
      hidden: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "noBps",
      text: "Produk Hukum",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      // formatter: (cell, row) => row.dashboardReferensi ? row.noBps : 'N/A', // Handle undefined case
      //   formatter: columnFormatters.DateFormatterMonitoringMatrix,
    },

    {
      dataField: "tglBps",
      text: "Tgl BPS",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      //   formatter: columnFormatters.DateFormatterMatrixPublikasi,
    },
    {
      dataField: "refJenisSurat",
      text: "Jenis Referensi",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: columnFormatters.StatusColumnFormatterDashboardJenisReferensi,
    },
    {
      dataField: "action",
      text: "Aksi",
      formatter: columnFormatters.ActionsColumnFormatterDashboard,
      formatExtraData: {
        openDetailDialog: detail,
        openCetakSuket: cetakSuket,
        openCetakBps: handleCetakBps,
      },
      classes: "text-center pr-0",
      headerClasses: "text-center pr-3",
      style: {
        minWidth: "100px",
      },
    },
  ];
  const initialFilter = {
    sortOrder: "asc", // asc||desc
    sortField: "tglBps",
    pageNumber: currentPage,
    pageSize: sizePage,
  };
  const defaultSorted = [
    { dataField: "tglBps", order: "asc" },
  ];
  const sizePerPageList = [
    { text: "30", value: 30 },
    { text: "75", value: 75 },
    { text: "100", value: 100 },
  ];
  const pagiOptions = {
    custom: true,
    // totalSize: content.length,
    totalSize: data.totalItems || 0,
    sizePerPageList: sizePerPageList,
    sizePerPage: initialFilter.pageSize, //default 10
    page: initialFilter.pageNumber, //curent page (default 1),
    onPageChange: (page, sizePerPage) => {
      setCurrentPage(page);
    },
    onSizePerPageChange: (page, sizePerPage) => {
      setSizePage(page);
      setCurrentPage(sizePerPage);
    },
  };
  // const emptyDataMessage = () => {
  //   return "Tidak Ada Data";
  // };
  const { SearchBar } = Search;
  const handleTableChange = (
    type,
    { sortField, sortOrder, data, filters, ...props }
  ) => {
    if (type === "search") {
      setCurrentPage(1);
      setSearchTxt(props.searchText);
      getDataDashboardByNpwp(
        npwp, 
        1, 
        sizePage,
        props.searchText,
      ).then(({data})=> {
        setLoading(false);
        if (data) {
          if (data.code === 1) {
            if (data.data.content.length > 0) {
              setContent(data.data.content);
              setData(data.data);
              setLoading(false);
            }
          } else {
            setLoading(false);
            swal({
              title: "Data Tidak Tersedia!",
              icon: "info",
              closeOnClickOutside: false,
            }).then((willApply) => {
              if (willApply) {
                // history.push("/logout");
              }
            });
          }
        }
      })
      // setCurrentPage(1);
      // setSearchTxt(props.searchText);
      // switch (tab) {
      //   case "true":
      //     getKnowledgeByJudulAndProbis(
      //       // currentPage,
      //       1,
      //       sizePage,
      //       props.searchText,
      //       "true"
      //     ).then(({ data }) => {
      //       if (data.content.length > 0) {
      //         setContent(data.content);
      //         setData(data);
      //       } else {
      //         swal({
      //           title: "Data Tidak Tersedia!",
      //           icon: "info",
      //           closeOnClickOutside: false,
      //         }).then((willApply) => {
      //           if (willApply) {
      //             // history.push("/logout");
      //           }
      //         });
      //       }
      //     });
      //     break;
      //   case "false":
      //     getKnowledgeByJudulAndProbis(
      //       // currentPage,
      //       1,
      //       sizePage,
      //       props.searchText,
      //       "false"
      //     ).then(({ data }) => {
      //       if (data.content.length > 0) {
      //         setContent(data.content);
      //         setData(data);
      //       } else {
      //         swal({
      //           title: "Data Tidak Tersedia!",
      //           icon: "info",
      //           closeOnClickOutside: false,
      //         }).then((willApply) => {
      //           if (willApply) {
      //             // history.push("/logout");
      //           }
      //         });
      //       }
      //     });
      //     break;
      //   default:
      //     break;
      // }
    }
    let result;
    if (sortOrder === "asc") {
      result = data.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return 1;
        } else if (b[sortField] > a[sortField]) {
          return -1;
        }
        return 0;
      });
      setContent(result);
    } else {
      result = data.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return -1;
        } else if (b[sortField] > a[sortField]) {
          return 1;
        }
        return 0;
      });
      setContent(result);
    }
  };
  const emptyDataMessage = () => {
    return <div className="text-center">Tidak Ada Data</div>;
  };
  return (
    <>
      <PaginationProvider pagination={paginationFactory(pagiOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <>
              <ToolkitProvider
                keyField="noBps"
                data={content}
                columns={columns}
                search
              >
                {(props) => (
                  <div>
                    <div className="row">
                      <div className="col-lg-6 col-xl-6 mb-3">
                        <SearchBar
                          {...props.searchProps}
                          style={{ width: "300px" }}
                          placeholder="Cari"
                        />
                        <br />
                      </div>
                      <div className="col-lg-6 col-xl-6 mb-3">
                        <button
                          type="button"
                          className="btn btn-primary"
                          style={{
                            boxShadow: "0px 8px 15px rgb(55 104 165 / 30%)",
                            float: "right",
                          }}
                          onClick={add}
                        >
                          <span className="svg-icon menu-icon">
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/Code/Plus.svg"
                              )}
                            />
                          </span>
                          Referensi Baru
                        </button>
                      </div>
                    </div>
                    <BootstrapTable
                      {...props.baseProps}
                      wrapperClasses="table-responsive"
                      bordered={false}
                      headerWrapperClasses="thead-light"
                      classes="table table-bordered table-condensed table-head-custom table-vertical-center overflow-hidden"
                      defaultSorted={defaultSorted}
                      bootstrap4
                      remote
                      noDataIndication={emptyDataMessage}
                      onTableChange={handleTableChange}
                      {...paginationTableProps}
                    ></BootstrapTable>
                    <Pagination
                      paginationProps={paginationProps}
                      isLoading={loading}
                    />
                  </div>
                )}
              </ToolkitProvider>
            </>
          );
        }}
      </PaginationProvider>
    </>
  );
}

export default DashboardTable;
